// @ts-nocheck
import fetch from '@adc/fetch'

const exposeErrorFromMutation = mutation => res => {
  const { errors, data } = res.body

  if (errors?.length) {
    /* eslint-disable-next-line no-throw-literal */
    throw { body: { title: errors[0].extensions.specificErrorCode } }
  }

  return data[mutation]
}

export const generatePhoneOTP = ({ phoneNumber, via }) =>
  fetch
    .forAuctionGraph({
      query: `
      mutation toolkitAdc_generateOTP($phoneNumber: String!, $via: OTPDeliveryMechanism!) {
        generateOTP(phone: $phoneNumber, via: $via) {
          uuid
          success
        }
      }
    `,
      variables: { phoneNumber, via },
    })
    .then(exposeErrorFromMutation('generateOTP'))

export const verifyPhoneOTP = ({ phoneNumber, otp }) =>
  fetch
    .forAuctionGraph({
      query: `
      mutation toolkitAdc_verifyOTP($phoneNumber: String!, $otp: String!) {
        verifyOTP(phone: $phoneNumber, otp: $otp) {
          phone_id
          phone_usage
          number
          verified
          opt_in
        }
      }
    `,
      variables: { phoneNumber, otp },
    })
    .then(exposeErrorFromMutation('verifyOTP'))

export const generatePhoneOTPForUser = ({ phoneNumber, via, userId }) =>
  fetch
    .forAuctionGraph({
      query: `
      mutation toolkitAdc_generateOTPForUser($phoneNumber: String!, $via: OTPDeliveryMechanism!, $userId: ID!) {
        generateOTPForUser(phone: $phoneNumber, via: $via, userId: $userId) {
          uuid
          success
        }
      }
    `,
      variables: { phoneNumber, via, userId },
    })
    .then(exposeErrorFromMutation('generateOTPForUser'))

export const verifyPhoneOTPForUser = ({ phoneNumber, otp, userId }) =>
  fetch
    .forAuctionGraph({
      query: `
      mutation toolkitAdc_verifyOTPForUser($phoneNumber: String!, $otp: String!, $userId: ID!) {
        verifyOTPForUser(phone: $phoneNumber, otp: $otp, userId: $userId) {
          phone_id
          phone_usage
          number
          verified
          opt_in
        }
      }
    `,
      variables: { phoneNumber, otp, userId },
    })
    .then(exposeErrorFromMutation('verifyOTPForUser'))

/**
 * Removes a phone record from a user via GraphQL mutation.
 * @param {{ phoneId: string, partyId: string }} params
 * @returns {Promise<any>}
 */
export const removePhone = ({ phoneId, partyId }) =>
  fetch.forAuctionGraph({
    query: `
      mutation toolkitAdc_removePhoneFromUser($phoneId: ID!, $partyId: ID!) {
        removePhoneFromUser(phoneId: $phoneId, partyId: $partyId)
      }
    `,
    variables: { phoneId, partyId },
  })
